import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import arrow from "../../../assets/svgs/arrow_right_new.svg";

const ButtonWithArrow = ({ children, buttonRole, onClick, href, to, ...props }) => {
  if (buttonRole === "link") {
    return (
      <A href={href} {...props}>
        {children}
        <img src={arrow} aria-hidden="true" alt="" />
      </A>
    );
  }
  if (buttonRole === "reactLink") {
    return (
      <ReactLink to={to} {...props}>
        {children}
        <img src={arrow} aria-hidden="true" alt="" />
      </ReactLink>
    );
  }
  return (
    <Button onClick={onClick} {...props}>
      {children}
      <img src={arrow} aria-hidden="true" alt="" />
    </Button>
  );
};

ButtonWithArrow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  buttonRole: PropTypes.oneOf(["link", "reactLink"]),
  onClick: PropTypes.func,
  href: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default ButtonWithArrow;

const style = css`
  text-decoration: none;
  font-size: 18px;
  line-height: 19px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-weight: 700;
  color: #000;
  display: inline-block;
  background: none;
  border: none;
  padding: 2px 0 0 0;
  cursor: pointer;
  text-align: left;

  img {
    display: inline-block;
    margin-left: 8px;
    vertical-align: middle;
  }
`;

const Button = styled.button`
  ${style}
`;

const A = styled.a`
  ${style}
`;
const ReactLink = styled(Link)`
  ${style}
`;
